// Truncate BOLD ranges on plan bullets so only the title segment (before the
// first '–' en-dash or ' - ' hyphen separator) is bolded. Idempotent: running
// it on already-correct data leaves the data unchanged. Used to repair stale
// JSON loaded from BE where the entire bullet line was bolded.
const normalizePlanBoldRanges = (dataMix) => {
  if (!dataMix || !dataMix.blocks || !Array.isArray(dataMix.blocks)) return dataMix;

  dataMix.blocks = dataMix.blocks.map((block) => {
    if (!block || block.type !== "unordered-list-item") return block;
    if (!Array.isArray(block.inlineStyleRanges) || block.inlineStyleRanges.length === 0) {
      return block;
    }
    const text = block.text || "";
    const enDashIdx = text.indexOf("–");
    const hyphenIdx = text.indexOf(" - ");
    let separatorIdx = -1;
    if (enDashIdx > -1 && hyphenIdx > -1) {
      separatorIdx = Math.min(enDashIdx, hyphenIdx);
    } else if (enDashIdx > -1) {
      separatorIdx = enDashIdx;
    } else if (hyphenIdx > -1) {
      separatorIdx = hyphenIdx;
    }
    if (separatorIdx <= 0) return block;

    const titleLength = text.substring(0, separatorIdx).trimEnd().length;
    if (titleLength <= 0) return block;

    const newRanges = block.inlineStyleRanges.map((range) => {
      if (range && range.style === "BOLD" && range.offset === 0 && range.length > titleLength) {
        return { ...range, length: titleLength };
      }
      return range;
    });
    return { ...block, inlineStyleRanges: newRanges };
  });

  return dataMix;
};

export default normalizePlanBoldRanges;
